import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody, Button, Table } from "reactstrap";
import { useParams, Link, useHistory } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Snackbars from "../../Utils/Snackbars";
import useRequests from "../../Utils/useRequests";

const CrewList = (props) => {
  const { id } = useParams();
  const history = useHistory();
  const { postRequest } = useRequests();
  const [AlertData, setAlertData] = useState({ variant: '', message: '' });
  const [crew, setCrew] = useState([]);
  const [loading, setLoading] = useState(true);

  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData({ variant: '', message: '' });
    }, 5000);
  };

    const [foremenData, setForemenData] = useState("");
  
  const handleLoadGetForemenInfo = async () => {
    const jsonpar = JSON.stringify({
      f_id: atob(id)
    });
    const res = await postRequest('get-foremen-info', jsonpar);
    if (res && res.code === 200 && res.data) {
      setForemenData(res.data.name);
    } else {
      setAlertData({ variant: 'error', message: res.message });
      resetAlertData();
    }
  };

  useEffect(() => {
    handleLoadGetForemenInfo();
    const fetchCrew = async () => {
      setLoading(true);
      const jsonpar = JSON.stringify({ f_id: atob(id) });
      const res = await postRequest('get-foremen-crew', jsonpar);
      if (res && res.code === 200 && Array.isArray(res.data)) {
        setCrew(res.data);
      } else {
        setAlertData({ variant: 'error', message: res.message || 'Failed to load crew members' });
      }
      setLoading(false);
      resetAlertData();
    };
    fetchCrew();
    // eslint-disable-next-line
  }, [id]);

  return (
    <React.Fragment>
      {AlertData.message && <Snackbars variant={AlertData.variant} message={AlertData.message} />}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Utilize Safety" breadcrumbItem={`Crew Members of ${foremenData}`} />
          <Card>
            <CardBody>
                <div className="d-flex justify-content-end align-items-center mb-3">
                  <Button color="light" onClick={() => history.goBack()}>
                    &larr; Back
                  </Button>
                </div>
              {loading ? (
                <div>Loading...</div>
              ) : crew.length > 0 ? (
                <div className="table-rep-plugin">
                  <div className="table-responsive mb-0">
                    <table className="table table-hover table-highlight" style={{ minWidth: '700px' }}>
                      <thead>
                        <tr>
                          <th>Employee Id</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Company Code</th>
                        </tr>
                      </thead>
                      <tbody>
                        {crew.map((member, idx) => (
                          <tr key={idx}>
                            <td>{member.emp_id || '-'}</td>
                            <td>{member.name || '-'}</td>
                            <td>{member.email || '-'}</td>
                            <td>{member.phone || '-'}</td>
                            <td>{member.company_code || '-'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="infoIcon">
                    <div className="infoIconBox">
                    </div>
                  </div>
                </div>
              ) : (
                <div>No crew members found for this foreman.</div>
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CrewList;
